<template>
  <div class="js-author-detail">
    <div class="content-header">
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'repositoryList' }">仓库</router-link>
        </li>
        <li class="active">(添加/修改)</li>
      </ol>
    </div>
    <div class="content-from">
      <el-form ref="formName" :model="seller" :rules="rules" label-width="auto">
        <el-form-item label="仓库名称">
          <el-input v-model="seller.name" placeholder="请输入仓库名称"></el-input>
        </el-form-item>
        <el-form-item label="产地名称">
          <el-input v-model="seller.placeOrigin" placeholder="请输入产地名称"></el-input>
        </el-form-item>
        <el-form-item label="联系人/寄件人姓名">
          <el-input v-model="seller.linkman" placeholder="联系人/寄件人姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="seller.telephone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="所在城市">
          <div class="block">
            <el-cascader
                @change="handleChange"
                :model="address"
                :value="address"
                :placeholder="placeholder"
                :options="options"
                :props="{ expandTrigger: 'hover' }"
                filterable
                clearable></el-cascader>
          </div>
        </el-form-item>
        <el-form-item label="仓库详细地址" prop="briefAddress">
          <el-input v-model="seller.detailAddress" placeholder="请输入仓库详细地址"></el-input>
        </el-form-item>
        <el-form-item label="仓库图片">
          <el-upload :action="serverUrl + '/file/upload'" :on-success="uploadSuccess" :limit="1">
            <el-button size="small" type="primary">上传</el-button>
            <div slot="tip" class="el-upload__tip">请上传200*200的图片</div>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="!sellerId" label="仓库管理系统登录名" prop="username">
          <el-input v-model="seller.username" placeholder="仓库管理系统登录名"></el-input>
        </el-form-item>
        <el-form-item v-if="!sellerId" label="密码" prop="password">
          <el-input v-model="seller.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item v-if="!sellerId" label="确认密码" prop="rePassword">
          <el-input v-model="seller.rePassword" type="password" placeholder="请输入确认密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveSeller" size="small">保存</el-button>
          <el-button @click="resetForm('formName')" size="small">重置</el-button>
          <el-button @click="$router.back(-1)" size="small">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      seller: {},
      sellerId: '',
      rules: {},
      serverUrl: config.hostUrl,
      address: [],
      options: [],
      placeholder: '输入关键字可搜索',
    }
  },
  created() {
    const _this = this;
    _this.sellerId = _this.$route.query.sellerId;
    if (_this.sellerId) {
      _this.$common.ajaxRequest({
        url: '/seller/detailSeller',
        data: {
          sellerId: _this.sellerId
        },
        type: 'post',
        success(response) {
          _this.seller = response.item || {}
          _this.address = [_this.seller.provinceId, _this.seller.cityId, _this.seller.countyId];
        }
      })
    }
  },
  mounted() {
    this.loadZone();
  },
  methods: {
    handleChange(value) {
      const _this = this;
      _this.address = value
    },
    uploadSuccess(res, file) {
      let _this = this;
      _this.seller.iconPath = res.msg;
    },
    loadZone() {
      const _this = this;
      _this.$common.ajaxRequest({
        url: '/address/findTreeZone',
        success(response) {
          let items = response.items || [];
          let options = [];
          items.forEach((v, i) => {
            let item = {};
            let itemChilds = [];
            if (v.children) {
              v.children.forEach((cv, ci) => {
                let itemChild = {};
                let itemChildChilds = [];
                if (cv.children && cv.children.length > 0) {
                  cv.children.forEach((ccv, cci) => {
                    let itemChildChild = {};
                    Object.assign(itemChildChild, {"value": ccv.id}, {"label": ccv.name});
                    itemChildChilds.push(itemChildChild);
                  })
                }
                Object.assign(itemChild, {"value": cv.id}, {"label": cv.name}, {"children": itemChildChilds});
                itemChilds.push(itemChild);
              });
            }
            Object.assign(item, {"value": v.id}, {"label": v.name}, {"children": itemChilds});
            options.push(item);
          });
          _this.options = options;
        }
      });
    },
    saveSeller() {
      var _this = this;
      _this.seller.provinceId = _this.address[0]
      _this.seller.cityId = _this.address[1]
      _this.seller.countyId = _this.address[2]
      if (_this.seller.provinceId && _this.seller.cityId && _this.seller.countyId) {
        _this.$common.ajaxRequest({
          url: '/seller/updateRepository',
          data: _this.seller,
          success(response) {
            _this.$message({
              message: '保存成功',
              type: 'success',
              duration: 1000,
              onClose: function () {
                _this.$router.push({name: 'repositoryList'});
              }
            });
          }
        })
      } else {
        _this.$message.error("请选择地区")
      }

    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
}

</script>

